export interface AperturaExclusion {
    fechaInicio: string;
    fechaFin: string;
}

export interface Apertura {
    ejercicio: number;
    mes: number;
    fechaInicio: string;
    fechaFin: string;
    aperturaExclusion?: AperturaExclusion;
}

export const Months = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre'
];
